import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { TextButton } from '../../../components/common';
import { MainSource } from '../../../constants/Source';
import { RouteBuilder } from '../../../utils/RouteHelpers';
import { Truncated } from './components/Truncated';
import { GenericNotification } from './GenericNotification';
import styles from './notifications.scss';

export const createNewBoardNotification =
  ({ board }) =>
  ({ notification }) =>
    (
      <GenericNotification
        notification={notification}
        text={
          <FormattedMessage
            id="boards.modal.create-new.notification"
            values={{
              boardLink: (
                <TextButton
                  as={Link}
                  size="small"
                  to={RouteBuilder.Source(MainSource.Boards, board.id)}
                  underline="always"
                  skin="dark"
                  dataHook="notification-link"
                >
                  <Truncated className={styles.newBoardName}>{board.name}</Truncated>
                </TextButton>
              ),
            }}
          />
        }
        dataHook="boards-create-notification"
      />
    );
